module.exports = __webpack_public_path__ + "img/bg_nav.e83b8f9b.png";